var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"response"},[_c('div',{staticStyle:{"overflow":"auto","width":"200px","padding":"0px 10px","text-align":"left","padding-right":"10px","border-right":"1px solid #f2f2f2","height":"calc(100vh - 96px)"}},[_c('responseRight',{on:{"modelFun":_vm.modelFun}})],1),_c('codeRight',{staticStyle:{"flex":"1"},attrs:{"str":_vm.str}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }